import CityPageTemplate from "../city-template/CityPageTemplate";
import { dearbornHeightsConfig } from "./data";

export default function DearbornHeightsPage() {
  return <CityPageTemplate config={dearbornHeightsConfig} />;
}